module.exports = __webpack_public_path__ + "img/AssociationLineEndIcon8.1bc068d7.svg";